import dayjs from 'dayjs'
export const dateFormat = (val, format = 'YYYY-MM-DD') => {
  if (isNaN(val)) {
    return val
  }
  val = parseInt(val)
  return dayjs(val).format(format)
}

export const translateTime = (val) => {
  const date = new Date(val)
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
}
